import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { auth } from '../firebase';
import {
  GoogleAuthProvider,
  signInWithPopup,
  signInWithRedirect,
  browserLocalPersistence,
  setPersistence,
} from 'firebase/auth';

import { toast } from 'sonner';
import { Lock, Loader2 } from 'lucide-react';
import { api } from '../lib/api';

const provider = new GoogleAuthProvider();
provider.setCustomParameters({ prompt: 'select_account' });

export default function LoginPage() {
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  const from = location.state?.from?.pathname || '/';

  const handleGoogleSignIn = async () => {
    setLoading(true);

    try {
      await setPersistence(auth, browserLocalPersistence);

      const result = await signInWithPopup(auth, provider);

      const fbUser = result.user;
      const idToken = await fbUser.getIdToken();

//    await api.post(
//      '/auth/verify-token',
//      {},
//      {
//        headers: {
//          Authorization: `Bearer ${idToken}`,
//        },
//       }
//    );

      toast.success('Signed in successfully');

      navigate(from, { replace: true });
    } catch (err) {
      console.error(err);

      const code = err?.code || '';

      if (
        code === 'auth/popup-blocked' ||
        code === 'auth/popup-closed-by-user'
      ) {
        await signInWithRedirect(auth, provider);
      } else {
        toast.error('Google sign-in failed');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-6">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-sm border border-slate-200 p-8">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-14 h-14 bg-indigo-600 rounded-full mb-4">
            <Lock className="w-7 h-7 text-white" />
          </div>

          <h1 className="text-3xl font-bold text-slate-900">
            TripLatch
          </h1>

          <p className="text-slate-600 mt-2">
            Lock your trip. Make plans real.
          </p>
        </div>

        <button
          onClick={handleGoogleSignIn}
          disabled={loading}
          className="w-full h-14 rounded-xl bg-white border border-slate-300 hover:bg-slate-50 transition flex items-center justify-center gap-3 font-medium"
        >
          {loading ? (
            <>
              <Loader2 className="w-5 h-5 animate-spin" />
              Signing in...
            </>
          ) : (
            <>
              Continue with Google
            </>
          )}
        </button>
      </div>
    </div>
  );
}
